import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

import { NgHelpComponent } from "./ng-help.component";

@NgModule({
    declarations: [
        NgHelpComponent
    ],
    imports: [
        CommonModule,
        TranslateModule
    ],
    exports: [
        NgHelpComponent
    ]
})
export class NgHelpModule {}
